import { render } from "./MiniProfileViewLink.vue?vue&type=template&id=bab2c240&ts=true"
import script from "./MiniProfileViewLink.vue?vue&type=script&lang=ts"
export * from "./MiniProfileViewLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__